var map = {
	"./easter_tour_mini_cover_1-1.png": "c6a5",
	"./easter_tour_mini_cover_1.png": "504e",
	"./easter_tour_mini_cover_2.png": "c33d",
	"./easter_tour_mini_cover_3.png": "a03e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "410e";